const BASE_FONT_SIZE = 16;

const remRatio = (fontSize: number) =>
  `${fontSize / BASE_FONT_SIZE}rem` as const;

export const typography = {
  /* Basic Texts */
  "small-text": remRatio(14),
  "normal-text": `16px`,
  "medium-text": remRatio(18),
  "large-text": remRatio(20),

  /*  Headlines */

  /* small series */
  headline6: remRatio(24),
  headline5: remRatio(26),
  headline4: remRatio(28),

  /* Big series */
  headline3: remRatio(36),
  headline2: remRatio(43),
  headline1: remRatio(65),
} as const;

export type Typography = keyof typeof typography;

export const fontWeights = {
  "light-weight": 300,
  "normal-weight": 400,
  "medium-weight": 500,
  "bold-weight": 600,
} as const;

export type FontWeight = keyof typeof fontWeights;
